import React, {PropsWithChildren} from 'react'

import {Row} from 'jsxstyle'

const ConfirmDialogFooter: React.FC<PropsWithChildren> = ({children}) => {
  return (
    <Row alignItems="center" justifyContent="flex-end" marginTop="0.8rem" gap="6px" background="#F8F8F8" padding="14px 28px">
      {children}
    </Row>
  )
}

export default ConfirmDialogFooter
